import { SectionBox } from '@shared/components/ui/SectionBox';
import { Button } from '@shared/components/ui/button';
import { faTag, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const CreateCode = ({ onCreate }: { onCreate?: () => void }) => {
  const { t } = useTranslation('affiliatesModule');
  return (
    <SectionBox className="mt-6 text-center !py-10">
      <FontAwesomeIcon icon={faTag} className="text-2xl mb-2" />
      <div className="text-xl font-bold my-2">{t('createCode.title')}</div>
      <div className="text-complementary-text text-sm mb-8">
        {t('createCode.emptyDescription')}
        <span className="text-primary font-semibold">{t('createCode.commissionPercent')}</span>
        {t('createCode.emptyDescription2')}
      </div>
      <Button variant="primary" size="lg" className="gap-2 mt-2 mx-auto" onClick={onCreate}>
        <FontAwesomeIcon icon={faPlus} className="w-4 h-4" />
        {t('createCode.button')}
      </Button>
    </SectionBox>
  );
};

export default CreateCode;
